module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./ContentForm.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/components/ContentForm.js
// module id = 1998
// module chunks = 4